import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { useSeo } from "@/hooks/useSeo";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import CantAccess from "@/pages/CantAccess";
import DashboardSocio from "@/pages/DashboardSocio";
import Profilo from "@/pages/Profilo";
import Investimento from "@/pages/Investimento";
import Documenti from "@/pages/Documenti";
import Faq from "@/pages/Faq";
import Notifiche from "@/pages/Notifiche";
import AuthCallback from "@/pages/AuthCallback";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminSoci from "@/pages/admin/AdminSoci";
import AdminDocumenti from "@/pages/admin/AdminDocumenti";
import AdminFaq from "@/pages/admin/AdminFaq";
import AdminRichieste from "@/pages/admin/AdminRichieste";
import AdminSeo from "@/pages/admin/AdminSeo";
import AdminGovernance from "@/pages/admin/AdminGovernance";
import AdminChatbot from "@/pages/admin/AdminChatbot";
import AdminCommunications from "@/pages/admin/AdminCommunications";
import AdminMercato from "@/pages/admin/AdminMercato";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminSurveys from "@/pages/admin/AdminSurveys";
import AdminReminders from "@/pages/admin/AdminReminders";
import AdminAssemblies from "@/pages/admin/AdminAssemblies";
import AdminAdmins from "@/pages/admin/AdminAdmins";
import GovernanceProfile from "@/pages/GovernanceProfile";
import Governance from "@/pages/Governance";
import Mercato from "@/pages/Mercato";
import Onboarding from "@/pages/Onboarding";
import Analytics from "@/pages/Analytics";
import Assemblee from "@/pages/Assemblee";

function RoleRedirect() {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (!user) return <Navigate to="/login" replace />;
    return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;
}

function SeoInjector() {
    useSeo();
    return null;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <SeoInjector />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/non-riesco-accedere" element={<CantAccess />} />
                        <Route path="/auth-callback" element={<AuthCallback />} />
                        <Route path="/governance" element={<Governance />} />
                        <Route path="/governance/:slug" element={<GovernanceProfile />} />
                        <Route path="/faq" element={<Faq />} />
                        <Route path="/redirect" element={<RoleRedirect />} />

                        {/* Area socio */}
                        <Route path="/app" element={<ProtectedRoute><DashboardSocio /></ProtectedRoute>} />
                        <Route path="/app/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
                        <Route path="/app/profilo" element={<ProtectedRoute><Profilo /></ProtectedRoute>} />
                        <Route path="/app/investimento" element={<ProtectedRoute><Investimento /></ProtectedRoute>} />
                        <Route path="/app/documenti" element={<ProtectedRoute><Documenti /></ProtectedRoute>} />
                        <Route path="/app/mercato" element={<ProtectedRoute><Mercato /></ProtectedRoute>} />
                        <Route path="/app/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
                        <Route path="/app/assemblee" element={<ProtectedRoute><Assemblee /></ProtectedRoute>} />
                        <Route path="/app/assemblee/:id" element={<ProtectedRoute><Assemblee /></ProtectedRoute>} />
                        <Route path="/app/faq" element={<ProtectedRoute><Faq /></ProtectedRoute>} />
                        <Route path="/app/notifiche" element={<ProtectedRoute><Notifiche /></ProtectedRoute>} />

                        {/* Area admin */}
                        <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminOverview /></ProtectedRoute>} />
                        <Route path="/admin/soci" element={<ProtectedRoute requireAdmin><AdminSoci /></ProtectedRoute>} />
                        <Route path="/admin/documenti" element={<ProtectedRoute requireAdmin><AdminDocumenti /></ProtectedRoute>} />
                        <Route path="/admin/faq" element={<ProtectedRoute requireAdmin><AdminFaq /></ProtectedRoute>} />
                        <Route path="/admin/richieste" element={<ProtectedRoute requireAdmin><AdminRichieste /></ProtectedRoute>} />
                        <Route path="/admin/seo" element={<ProtectedRoute requireAdmin><AdminSeo /></ProtectedRoute>} />
                        <Route path="/admin/governance" element={<ProtectedRoute requireAdmin><AdminGovernance /></ProtectedRoute>} />
                        <Route path="/admin/chatbot" element={<ProtectedRoute requireAdmin><AdminChatbot /></ProtectedRoute>} />
                        <Route path="/admin/communications" element={<ProtectedRoute requireAdmin><AdminCommunications /></ProtectedRoute>} />
                        <Route path="/admin/mercato" element={<ProtectedRoute requireAdmin><AdminMercato /></ProtectedRoute>} />
                        <Route path="/admin/surveys" element={<ProtectedRoute requireAdmin><AdminSurveys /></ProtectedRoute>} />
                        <Route path="/admin/audit" element={<ProtectedRoute requireAdmin><AdminAudit /></ProtectedRoute>} />
                        <Route path="/admin/reminders" element={<ProtectedRoute requireAdmin><AdminReminders /></ProtectedRoute>} />
                        <Route path="/admin/assemblies" element={<ProtectedRoute requireAdmin><AdminAssemblies /></ProtectedRoute>} />
                        <Route path="/admin/admins" element={<ProtectedRoute requireAdmin><AdminAdmins /></ProtectedRoute>} />

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
